<div class="loading-container" #loadingContainerDiv>
  <div class="loading-content" #loadingContentDiv>
    <ng-container *ngTemplateOutlet="mainContent"/>
  </div>
  <div class="loading-indicator" #loadingIndicatorDiv>
    <ng-container *ngTemplateOutlet="loadingIndicator"/>
  </div>
</div>
